import Config from '../Config';
export const isMobileOrTablet = () => {
  return window.innerWidth < Config.TabletBreakPoint;
};
